module.exports = __webpack_public_path__ + "static/architecture-b46f5e97a52214698704397ba0838fb8.svg";